import { render, staticRenderFns } from "./FeedbackBar.vue?vue&type=template&id=272399bb&scoped=true"
import script from "./FeedbackBar.vue?vue&type=script&lang=js"
export * from "./FeedbackBar.vue?vue&type=script&lang=js"
import style0 from "./FeedbackBar.vue?vue&type=style&index=0&id=272399bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272399bb",
  null
  
)

export default component.exports